<div class="box-menu-settings" [class.active]="isDeformityDone">

	<div class="row-box">
		<h4>{{ labels().TOOLS_MENU_COMPONENT_RPM }}</h4>
	</div>

	<div class="divider-box"></div>

	@if (stateType !== stateTypeEnum.RPM) {
	<div data-testid="SUBSYS4_RPMMENU_ACTIVATE_BTN" class="row-box"
		[class]="{'clickable': isDeformityDone, 'not-allowed': !isDeformityDone }" (click)="enableRPM()"
		(keypress)="enableRPM()">
		<i class="material-icons">more_horiz</i>
		<span>{{ labels().TOOLS_MENU_COMPONENT_ACTIVATE }}</span>
	</div>
	} @else {
	<div data-testid="SUBSYS4_RPMMENU_RPM_BTN" class="row-box clickable" (click)="redirectToFitbone()"
		(keypress)="redirectToFitbone()">
		<i class="material-icons">double_arrow</i>
		<span>{{ labels().TOOLS_MENU_COMPONENT_GO_TO_RPM }}</span>
	</div>
	}

</div>